import axios from 'axios'
import { forEach, mixin, singularize, camelCase, upperFirst } from 'lodash'

function getCookieValue(a) {
  if(typeof document !== 'undefined') {
    let b = document.cookie.match('(^|;)\\s*' + a + '\\s*=\\s*([^;]+)');
    return b ? b.pop() : '';
  }

  return '';
}

class API {
  constructor(config) {
    this.config = config
  }

  getBaseUrl() {
    return this.config.base
  }

  getApiUrl() {
    return this.config.api
  }

  getAuthUrl() {
    return this.config.auth
  }

  getToken() {
    return this.config.token
  }

  getAccount() {
    return this.config.account
  }

  tokenHeader() {
    const token = this.getToken();
    if(token) {
      return {'Authorization': `Token ${this.getToken()}`}
    }

    return {};
  }

  acceptHeader() {
    return {'Accept': `application/json;`};
  }

  csrfHeader() {
    const csrftoken = getCookieValue('csrftoken');

    if(csrftoken) {
      return {'X-CSRFToken': csrftoken};
    }

    return {};
  }

  languageConfigName() {
    if(this.config.configLanguageKey) {
      return this.config.configLanguageKey;
    }
    return 'uiLanguage'
  }

  languageHeader() {
    const language = this.config[this.languageConfigName()];
    return {'Accept-Language': language}
  }

  call(url, method, data, params, requestHeaders = {}, config = {}, sendAuth = true) {
    const headers = Object.assign({}, sendAuth ? this.tokenHeader() : {}, this.acceptHeader(), this.languageHeader(), requestHeaders);
    let request = {
      ...config,
      method: method,
      url: url
    };

    if (data) {
      request.data = data
    }
    if (headers) {
      request.headers = headers
    }
    if (params) {
      request.params = params
    }
    // request.withCredentials =  true
    return axios(request)
  }

  // For calling routes in API
  callRoute(route, method, data, params, headers = {}, config = {}) {
    return this.call(this.getApiUrl() + route, method, data, params, headers, config)
  }

  login(username, password) {
    return this.call(this.getAuthUrl(), 'POST', {username, password}, null, {}, {}, false)
  }

  fetchList(route, params) {
    return this.callRoute(`${route}/`, 'GET', null, params)
  }

  fetchEntity(route, id, params) {
    return this.callRoute(`${route}/${id}/`, 'GET', null, params)
  }

  updateEntity(route, id, data) {
    return this.callRoute(`${route}/${id}/`, 'PATCH', data, null)
  }

  createEntity(route, data) {
    return this.callRoute(`${route}/`, 'POST', data, null)
  }

  deleteEntity(route, id, data) {
    return this.callRoute(`${route}/${id}/`, 'DELETE', data, null)
  }

  fetchOptions(route, id, params) {
    if(id) {
      return this.callRoute(`${route}/${id}/`, 'OPTIONS', null, params)
    }else {
      return this.callRoute(`${route}/`, 'OPTIONS', null, params)
    }
  }

  fetchRouteOptions(route, params) {
    return this.callRoute(`${route}/`, 'OPTIONS', null, params)
  }

  getUsers() {
    return this.callRoute('users/', 'GET');
  }

  uploadFile(data, progressHandler) {
    return this.callRoute('file-uploads/', 'POST', data, null, {}, {
      onUploadProgress: progressHandler
    })
  }

  orderAction(url, params) {
    return this.call(url, 'POST');
  }

  orderExport(filters, format, shopId) {

    let request = {
      method: 'POST',
      url: `${this.getBaseUrl()}order/export-orders/`,
      responseType: 'blob'
    };

    request.data = {
      filters: filters,
      format: format,
      token: this.getToken(),
      shop_id: shopId
    };

    return axios(request)
  }
}

export default API
